document.addEventListener('DOMContentLoaded', () => {
  function toggleDisplay() {
    const manufacturerElement = document.getElementById(
      'wizard_create_case_capture_vehicle_information_vehicle_manufacturer'
    );
    const otherManufacturerElement = document.getElementById(
      'vehicle_other_manufacturer_field'
    );

    if (manufacturerElement.value === 'Other') {
      otherManufacturerElement.removeAttribute('hidden');
    } else {
      otherManufacturerElement.setAttribute('hidden', '');
    }
  }

  toggleDisplay();

  document
    .getElementById(
      'wizard_create_case_capture_vehicle_information_vehicle_manufacturer'
    )
    .addEventListener('change', () => toggleDisplay());
});
